import { gql } from '@apollo/client';
import { datadogRum } from '@datadog/browser-rum';
import { useCallback } from 'react';
import { subscriptionsPublicClient } from 'lib/apollo/clients';
import { groupBy } from 'lodash';

export const BUNDLE_PRICE = gql`
  query bundlePrice($bundle: String) {
    bundlePrice(bundle: $bundle) {
      price
      productSlug
      term
    }
  }
`;
const useBundlePrice = () =>
  useCallback(async (bundle) => {
    try {
      const {
        data: { bundlePrice },
      } = await subscriptionsPublicClient.query({
        query: BUNDLE_PRICE,
        variables: { bundle: bundle ?? 'essentials_v2_trial' },
      });

      return transformResponse(bundlePrice);
    } catch (e) {
      datadogRum.addError(new Error(e));
    }
  }, []);

const transformResponse = (results) => {
  const grouped = groupBy(results, 'productSlug');

  return Object.keys(grouped).reduce((acc, key) => {
    const bundlePrices = grouped[key];
    acc[key] = buildPlanDetails(bundlePrices);
    return acc;
  }, {});
};

const buildPlanDetails = (bundlePrices) => {
  return bundlePrices.reduce((acc, { term, productSlug, price }) => {
    return {
      ...acc,
      ...{
        bundle: productSlug,
        [`${term}Price`]: price,
      },
    };
  }, {});
};
export default useBundlePrice;
